(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-home-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mc-banner-carousel')) {
  customElements.define('mc-banner-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.slides = [...this.querySelectorAll('.mc-banner-slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pause = this.querySelector('[data-pause]');
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.dots.forEach((button,i)=>button.addEventListener('click',()=>{this.show(i);this.schedule()},options));
      this.pause.addEventListener('click',()=>{this.paused=!this.paused;this.sync();this.schedule()},options);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule()},options);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},options);
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.schedule()}},options);
      this.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));this.schedule()}},options);
      this.addEventListener('touchstart',event=>{this.touchX=event.changedTouches[0].clientX;this.touchY=event.changedTouches[0].clientY},{...options,passive:true});
      this.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-this.touchX;const dy=event.changedTouches[0].clientY-this.touchY;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)){this.show(this.index+(dx<0?1:-1));this.schedule()}},{...options,passive:true});
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.sync();this.schedule();
    }
    show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)));}
    sync(){this.pause.textContent=this.paused?this.pause.dataset.play:this.pause.dataset.stop;this.pause.setAttribute('aria-pressed',String(this.paused));}
    schedule(){clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule()},7000);}
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
